export const SEARCH_CLIENT_LEAD_COOKIE_KEY = 'searchClientLead';

export const DEFAULT_SORT_TYPE = 'client_creat_desc';
